<template>
  <v-autocomplete
      v-model="options"
      :items="list"
      :label="label"
      :loading="loading"
      :rules="rules"
      :search-input.sync="search"
      :item-text="getItemText"
      :disabled="disabled"
      item-value="id"
      return-object
      hide-no-data
      hide-details
      auto-select-first
      clearable
      outlined
      dense
  ></v-autocomplete>
</template>

<script>
import {default as ContractApi} from "@/api/erp/contract/ContractApi";

export default {
  name: "OaUserSelect",
  data: () => ({
    loading:false,
    list:[],
    search:null,
  }),
  props: {
    value: {
      type: Object,
    },
    label: {
      type: String,
      default :''
    },
    rules:{
      type: Array
    },
    disabled:{
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'value',
    event: 'modify',
  },
  watch: {
    search (val) {
      this.list = []
      if(this.value){
        val && val !== (this.value.name + '(' + this.value.orgAccountName + '-' + this.value.orgDepartmentName + '-' + this.value.orgPostName + ')')
        && this.listOaUser(val)
      }else if(val){
        this.listOaUser(val)
      }

    },
  },
  computed: {
    options: {
      get: function () {
        if(this.value && this.value.id && this.list.length == 0){
          this.list = [this.value];
        }
        return this.value //将props中的typeId值赋给value
      },
      set: function (val) {
        this.$emit('modify', val) //通过$emit触发父组件
      },
    },
  },
  methods: {
    listOaUser(name){
      let me = this;
      this.loading = true;
      ContractApi.listOaUser({name:name}).then(data=> {
              me.loading = false;
              me.list = data;
      }).catch(error=>{
              me.loading = false;
          })
    },
    getItemText(oaUser){
      return `${oaUser.name}(${oaUser.orgAccountName}-${oaUser.orgDepartmentName}-${oaUser.orgPostName})`;
    }
  }
}
</script>

<style scoped>

</style>